import React from "react";

const tabs = [
  { value: "route", label: "Маршруты" },
  { value: "receipt", label: "Квитанции" },
  { value: "product", label: "Товары" },
];

export default function EntityTypeTabs({ entityType, setEntityType }) {
  return (
    <div
      style={{
        display: "inline-flex",
        borderRadius: "999px",
        border: "1px solid #e2e8f0",
        background: "#f8fafc",
        padding: "2px",
        marginBottom: "0.75rem",
      }}
    >
      {tabs.map((tab) => {
        const active = entityType === tab.value;
        return (
          <button
            key={tab.value}
            type="button"
            onClick={() => setEntityType(tab.value)}
            style={{
              borderRadius: "999px",
              border: "none",
              padding: "0.35rem 0.9rem",
              fontSize: "0.85rem",
              cursor: "pointer",
              background: active ? "#ffffff" : "transparent",
              boxShadow: active ? "0 1px 4px rgba(15, 23, 42, 0.08)" : "none",
              color: active ? "#0f172a" : "#64748b",
              fontWeight: active ? 600 : 500,
              transition: "all 0.15s ease",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
